/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { useIntl } from 'react-intl';
import { createUseStyles } from 'react-jss';

import styles from './TopBarWithBackButton.style';

import TopBar from './TopBar';
import ArrowHeadIcon from 'src/shared/ui/component/icon/ArrowHeadIcon';
import messages from 'src/shared/app/base/l10n/uiL10n';

import type { TopBarProps } from './type/topBarTypes';

type Props = TopBarProps;

const useStyles = createUseStyles(styles);

const TopBarWithBackButton = (props: Props): React.Node => {
  /*
   |------------------------------------------------------------------------------
   | Hooks
   |------------------------------------------------------------------------------
   */

  const intl = useIntl();

  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes: Object = useStyles();

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return (
    <TopBar
      {...props}
      cancelLabel={
        <span className={classes.backSection}>
          <ArrowHeadIcon left />
          <span className={classes.text}>
            {props.cancelLabel || intl.formatMessage(messages.back)}
          </span>
        </span>
      }
    />
  );
};

// Make variants available
export * from './TopBar';

export default compose(React.memo)(TopBarWithBackButton);
